import { Modal, Table } from '@mairistem/composants';
import { formatMontant } from '@mairistem/finances-utils';
import Decimal from 'decimal.js';
import React from 'react';
import type ProjetRow from '../../../interfaces/common/projetRow';
import './Modal.css';

interface ModalCreditPaiementProps {
	exercice: string;
	onClose: () => void;
	projetRow: ProjetRow | null;
}

const ModalCreditPaiement = ({
	exercice,
	onClose,
	projetRow,
}: ModalCreditPaiementProps) => {
	let creditInitial = new Decimal(0);
	let rarN = new Decimal(0);
	let rarN1 = new Decimal(0);
	let reechelonnement = new Decimal(0);

	if (projetRow) {
		projetRow?.financements?.forEach((financement) => {
			creditInitial = creditInitial.add(financement.montant || 0);
			rarN = rarN.add(financement.rarN || 0);
			rarN1 = rarN1.add(financement.rarN1 || 0);
			reechelonnement = reechelonnement.add(financement.revision || 0);
		});

		projetRow?.children?.forEach((composant) => {
			composant?.financements?.forEach((financement) => {
				creditInitial = creditInitial.add(financement.montant || 0);
				rarN = rarN.add(financement.rarN || 0);
				rarN1 = rarN1.add(financement.rarN1 || 0);
				reechelonnement = reechelonnement.add(financement.revision || 0);
			});
		});
	}

	return (
		<Modal closeIcon open size="tiny" onClose={onClose}>
			<Modal.Header>Détail du crédit de paiement {exercice}</Modal.Header>
			<Modal.Content>
				<Table celled>
					<Table.Body>
						<Table.Row>
							<Table.Cell>Crédit initial</Table.Cell>
							<Table.Cell textAlign="right">
								{formatMontant(
									creditInitial.toNumber(),
									null,
									true,
									null,
									false,
									true,
								)}
							</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Rééchelonnement</Table.Cell>
							<Table.Cell textAlign="right">
								{formatMontant(
									reechelonnement.toNumber(),
									null,
									true,
									null,
									false,
									true,
								)}
							</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Reste à Réalisé N-1</Table.Cell>
							<Table.Cell textAlign="right">
								{formatMontant(rarN1.toNumber(), null, true, null, false, true)}
							</Table.Cell>
						</Table.Row>
						<Table.Row>
							<Table.Cell>Reste à Réalise N</Table.Cell>
							<Table.Cell textAlign="right">
								{formatMontant(rarN.toNumber(), null, true, null, false, true)}
							</Table.Cell>
						</Table.Row>
					</Table.Body>

					<Table.Footer>
						<Table.Row>
							<Table.HeaderCell colspan="6">
								<div className="table-footer-total">
									<span>Total</span>
									<span>{formatMontant(projetRow.creditPaiement)}</span>
								</div>
							</Table.HeaderCell>
						</Table.Row>
					</Table.Footer>
				</Table>

				<span className="legend">
					Total : Crédit Initial + Rééchelonnement + Reste à Réalise N-1 - Reste
					à Réalisé N
				</span>
			</Modal.Content>
		</Modal>
	);
};

export default ModalCreditPaiement;
